export interface CsbFileItem {
    type: UploadType;
    filename: string;
    size?: number;
    icon?: string;
    mimeType: string;
    link?: string;
    data?: ArrayBuffer
}

export enum UploadType {
    Local,
    DropBox,
    OneDrive,
    GoogleDrive,
    None
}

export function isFileItem(value: any): value is CsbFileItem {
    return !!value?.filename && !!value?.mimeType;
}